import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class NgrokInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Solo aplicar este interceptor a URLs de ngrok
    if (!request.url.includes('ngrok')) {
      return next.handle(request);
    }

    // Agregar headers específicos para ngrok
    const ngrokRequest = request.clone({
      setHeaders: {
        'ngrok-skip-browser-warning': 'true',
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    return next.handle(ngrokRequest).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          console.log('Respuesta recibida:', {
            bodyType: typeof event.body,
            body: event.body
          });

          // Si la respuesta es HTML en lugar de JSON, es probable que sea la página de advertencia de ngrok
          if (typeof event.body === 'string' && event.body.includes('<!DOCTYPE html>')) {
            console.error('NgrokInterceptor: Recibida página HTML de ngrok en lugar de JSON');
            console.error('Esto indica que el header ngrok-skip-browser-warning no funcionó');
            
            // Crear un error personalizado
            const error = new HttpErrorResponse({
              error: 'Ngrok devolvió HTML en lugar de JSON. Verifica la configuración del backend.',
              status: 502,
              statusText: 'Bad Gateway - Ngrok HTML Response',
              url: request.url
            });
            
            throw error;
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('NgrokInterceptor: Error en petición a ngrok:', {
          status: error.status,
          statusText: error.statusText,
          message: error.message,
          error: error.error
        });

        // Si el error tiene status 200 pero Angular lo trata como error,
        // probablemente es un problema de parsing
        if (error.status === 200) {
          console.error('NgrokInterceptor: Status 200 tratado como error - problema de parsing JSON');
          
          // Intentar parsear manualmente si es posible
          if (typeof error.error === 'string') {
            try {
              const parsedData = JSON.parse(error.error);
              // Crear una respuesta exitosa con los datos parseados
              const successResponse = new HttpResponse({
                body: parsedData,
                status: 200,
                statusText: 'OK',
                url: request.url
              });
              
              return new Observable<HttpEvent<any>>(observer => {
                observer.next(successResponse);
                observer.complete();
              });
            } catch (parseError) {
              console.error('NgrokInterceptor: Error al parsear JSON manualmente:', parseError);
            }
          }
        }

        return throwError(() => error);
      })
    );
  }
}
